/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbox_State_IdleInputs */

const en_inbox_state_idle = /** @type {(inputs: Inbox_State_IdleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ready`)
};

const id_inbox_state_idle = /** @type {(inputs: Inbox_State_IdleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`siap`)
};

/**
* | output |
* | --- |
* | "ready" |
*
* @param {Inbox_State_IdleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const inbox_state_idle = /** @type {((inputs?: Inbox_State_IdleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_State_IdleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_inbox_state_idle(inputs)
	return en_inbox_state_idle(inputs)
});